/* eslint no-undef: 'off' */
import $ from "jquery";
// import call_ajax from "../helpers/ajax";

const init = () => {
  initCustomCartCheckout();
};

const triggerAjax = () => {
  const ajax = parameters.ajax_custom_cart_checkout;

  $.ajax({
    url: parameters.url_admin_ajax,
    type: "POST",
    data: {
      nonce: ajax.nonce,
      action: ajax.action,
    },
    beforeSend: loadingScreen,
    success: function (res) {
      redirectPage(res.data);
    },
    error: function (err) {
      console.error("There's seems to be error" + err.responseText); // eslint-disable-line no-console
    },
  });
};

const initCustomCartCheckout = () => {
  $(".custom-cart-checkout").on("click", function () {
    triggerAjax();
  });
};

const redirectPage = (data) => {
  location.href = data.redirect_url;
};

const loadingScreen = () => {
  $(".custom-cart-checkout").addClass("loading");
};

try {
  init();
} catch (error) {
  console.error();
}
